import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Event Details',
    label: 'ข้อมูลรอบการสอบ',
    path: '/:examCenterCode/exam-events/:examEventId',
    requiredPermission: [APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW],
  },
  {
    value: 'Registration Details',
    label: 'ข้อมูลการสมัครสอบ',
    path: '/:examCenterCode/exam-events/:examEventId/examinees',
    requiredPermission: [APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW],
  },
  {
    value: 'Exam Result Details',
    label: 'ข้อมูลผลการสอบ',
    path: '/:examCenterCode/exam-events/:examEventId/results',
    requiredPermission: [APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW],
  },
];

export default function ExamEventDetailsNavigationTabs() {
  const { permissions } = usePermission();

  const filteredTabItems = useMemo(() => {
    return TAB_ITEMS.filter((tab) =>
      tab.requiredPermission?.every((permission) => permissions.includes(permission)),
    );
  }, [permissions]);

  return <NavigationTabs items={filteredTabItems} />;
}
